import React, { useContext, useEffect, useRef } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { CHAIN } from "../utils/constants/config";
import { Cardano, Ethereum } from "../views/pages/index";
import {
  CardanoHeader,
  EthHeader,
  InventoryComponent,
  Faqs,
  Modals,
} from "../components";
import SuccessModal from "../components/SuccessModal";
import LandingPage from "../pages/LandingPage";
import { runCardanoTimer, runEthTimer } from "../utils/helpers/functions";
import { AppContext } from "../components/walletsManagment/connectors";

const EthLayout = () => {
  const timerRef = useRef(null);
  const mounted = useRef(false);

  const setUpSlotTimmer = () => {
    timerRef.current = null;
    runEthTimer({
      setTimerInstance: (instance) => {
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = instance;
      },
      startNextSlot: () => {
        if (timerRef.current) clearInterval(timerRef.current);
        if (mounted.current) setUpSlotTimmer();
      },
    });
  };
  useEffect(() => {
    setUpSlotTimmer();
    return () => {
      mounted.current = false;

      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return (
    <>
      <EthHeader chain={CHAIN.EITH} />

      <Outlet />
    </>
  );
};

const CardanoLayout = () => {
  const timerRef = useRef(null);
  const mounted = useRef(false);
  const setUpSlotTimmer = () => {
    timerRef.current = null;
    runCardanoTimer({
      setTimerInstance: (instance) => {
        if (timerRef.current) clearInterval(timerRef.current);

        timerRef.current = instance;
      },
      startNextSlot: () => {
        if (timerRef.current) clearInterval(timerRef.current);
        if (mounted.current) setUpSlotTimmer();
      },
    });
  };
  useEffect(() => {
    mounted.current = true;

    setUpSlotTimmer();
    return () => {
      mounted.current = false;

      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return (
    <>
      <CardanoHeader chain={CHAIN.CARDANO} />
      <Outlet />
    </>
  );
};

const MainRoutes = () => {
  const { isCardanoEnabled } = useContext(AppContext);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route exact path="/wlconfirm" element={<PrivateRoute />}>
          <Route exact path="/wlconfirm" element={<SuccessModal />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />

        <Route path="/monsterzone" element={<EthLayout />}>
          <Route index element={<Ethereum />} />
          <Route
            path="/monsterzone/inventory"
            element={<InventoryComponent chain={CHAIN.EITH} />}
          />
        </Route>

        {isCardanoEnabled && (
          <Route path="/monsterzone/cardano" element={<CardanoLayout />}>
            <Route index element={<Cardano />} />
            <Route
              path="/monsterzone/cardano/inventory"
              element={<InventoryComponent chain={CHAIN.CARDANO} />}
            />
          </Route>
        )}
        <Route path="/monsterzone/faqs" element={<EthLayout />}>
          <Route index element={<Faqs />} />
        </Route>
        {/* <Route path="/modals" element={<Modals />} /> */}
      </Routes>
    </BrowserRouter>
  );
};

function PrivateRoute() {
  return localStorage.getItem("connectedCheck") ? (
    <Outlet />
  ) : (
    <Navigate to="/" />
  );
}

export default MainRoutes;
